import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { IssueDeactivationInstruction } from '../../../models';
import { IssueDeactivationInstructionService } from '../../../services';
import { DeactivationConfirmationFormComponent } from '../deact-confirmation-form/deactivation-confirmation-form.component';

@Component({
  selector: 'nexweb-deactivation-instructing-tso-confirmation',
  templateUrl: './deact-instruct-tso-conf.component.html',
  imports: [DeactivationConfirmationFormComponent, AsyncPipe],
})
export class DeactivationInstructingTsoConfirmationComponent implements OnInit {
  @Input() bidId: number;

  public notification$: Observable<IssueDeactivationInstruction.DeactivationInstruction>;
  public dateTimeFormat: string;
  public labels: IssueDeactivationInstruction.Labels;
  public headings: IssueDeactivationInstruction.Headings;

  private bmFacade = inject(BmDataAccessFacade);
  private issueDeactivationInstructionService = inject(IssueDeactivationInstructionService);

  ngOnInit(): void {
    this.labels = this.issueDeactivationInstructionService.getConfirmationLabels();
    this.headings = this.issueDeactivationInstructionService.getConfirmationHeadings();
    this.dateTimeFormat = this.issueDeactivationInstructionService.getDateTimeFormat();

    this.initialiseData();
  }

  private initialiseData(): void {
    this.notification$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map((bidNotificationInfo: BidNotificationInfo) => {
        const bidNotificationData = {
          supplyingTsoName: bidNotificationInfo.supplyingTsoName,
          supplyingTsoTelephoneNumber: bidNotificationInfo.supplyingTsoPhoneNumber,
          bspPortfolio: bidNotificationInfo.supplyingBspPortfolioName,
          tsoName: bidNotificationInfo.requestingTsoName,
          tsoTelephoneNumber: bidNotificationInfo.requestingTsoPhoneNumber,
          tsoPortfolio: bidNotificationInfo.requestingTsoName,
          orderQuantity: bidNotificationInfo.requestedQuantity,
          confirmedFullDispatchTime: bidNotificationInfo.confirmedFullDispatchTime,
          fullyDeactivatedTime: bidNotificationInfo.deactivationDispatchTime,
        } as IssueDeactivationInstruction.DeactivationInstruction;

        return bidNotificationData;
      }),
    );
  }
}
